export const calculateYearlyInterest = (monthlyInterest) => {
  if (!monthlyInterest) return 0;
  return ((Math.pow(1 + monthlyInterest / 100, 12) - 1) * 100).toFixed(2);
};

export const calculatePgto = (taxa, nper, vp) => {
  if (nper === 0) {
    return 0.0;
  }
  if (taxa === 0) {
    return (vp / nper).toFixed(2);
  }
  return ((vp * taxa) / (1 - Math.pow(1 + taxa, -nper))).toFixed(2);
};

export const calculateInstallmentQuestionedValue = (
  installment_value,
  not_questioned_value
) => {
  return Number(installment_value - not_questioned_value).toFixed(2);
};

export const calculateDaysDifference = (dateIni, dateFin) => {
  if (!dateIni || !dateFin) {
    return 0;
  }
  const d1 = new Date(dateIni);
  const d2 = new Date(dateFin);
  const differenceInTime = d2.getTime() - d1.getTime();
  return Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));
};
